import { Component, OnInit, OnDestroy } from '@angular/core';
import { sweetAlert } from 'src/app/utils/swal';
import { DispatchCenterService } from 'src/app/service/dispatch-center-service/dispatch-center-service';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import * as moment from 'moment-timezone';


@Component({
  selector: 'app-notification-details',
  templateUrl: './notification-details.component.html',
  styleUrls: ['./notification-details.component.css']
})
export class NotificationDetailsComponent implements OnInit, OnDestroy {
  search = '';
  user;
  timeZone;
  searchDate;
  notifications = [];
  isShowStatusDropdown = false;
  startDate;
  notificationStatuses = []
  selectedStatuses: string[] = [];
  statusLabelMap = {
    arrived: 'On Scene',
    started: 'Member Onboard',
  };
  filteredNotifications = []; // status-filtered list
  constructor(
    private sharedDataService: SharedDataService,
    private dispatchCenterService: DispatchCenterService
  ) {
  }

  ngOnInit() {
    this.getUser();
    this.getNotifications();
  }

  getNotifications() {
    this.dispatchCenterService
      .getNotifications(this.startDate)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.notifications = data;
          this.extractStatuses();
          this.applyStatusFilter();
        }
      }, err => {
        // sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  extractStatuses() {
    const statuses = Array.from(new Set(this.notifications.map(n => n.status)));

    this.notificationStatuses = statuses.map(status => ({
      status,
      label: this.statusLabelMap[status] || this.capitalize(status)
    }));

    this.selectedStatuses = [];
    this.filteredNotifications = [...this.notifications];
  }


  capitalize(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  getUser() {
    this.sharedDataService.getUser().subscribe(data => {
      if (data) {
        this.user = data;
        this.timeZone = this.user.company.timeZone;
        this.searchDate = moment().tz(this.timeZone).startOf('day').toISOString();
        this.startDate = moment().tz(this.timeZone).startOf('day').toISOString();
      }
    })
  }

  onSearchDateChange(event) {
    // console.log('toISOString', event.toISOString(), event.tz(this.timeZone).startOf('day').toISOString());
    this.searchDate = event.toISOString();
    this.startDate = this.searchDate;
    this.getNotifications();
  }

  toggleStatusDropdown() {
    this.isShowStatusDropdown = !this.isShowStatusDropdown
  }
  onChangeStatus() {
    this.applyStatusFilter();

  }

  applyStatusFilter() {
    if (this.selectedStatuses.length === 0) {
      // 👉 Show all if nothing is selected
      this.filteredNotifications = [...this.notifications];
    } else {
      this.filteredNotifications = this.notifications.filter(n =>
        this.selectedStatuses.includes(n.status)
      );
    }
  }

  ngOnDestroy(): void {
  }
}
